import React from "react"
import Section from "../../../../../core/layout/main/section/Section"
import CardDetails from "../../../../common/blocks/card/CardDetails"
import Button from "../../../../common/blocks/button/Button"
import Icon from "../../../../common/blocks/icon/Icon"
import * as classNames from "./RhCtxJobAdViewerSection.module.scss"
import Card from "../../../../common/blocks/card/Card"
import DialogApplicationForm from "../../../blocks/dialog/DialogApplicationForm"
import { navigate } from "gatsby"
import { isMobileDevice } from "../../../../../../utils/isDevice"

const CtxJobAdViewerSection = ({
  jobTitle,
  jobMission,
  jobProfile,
  jobCriteres,
  jobSalaryAmount,
  applicationEmail,
  agenceAdresse,
  agenceName,
  agenceSlug,
  agenceCollegues,
}) => {
  const openDialog = () => {
    const dialog = document.querySelector("dialog")
    dialog.showModal()
  }
  const criteres = jobCriteres.data
  return (
    <Section
      className={classNames.annonce}
      container="large"
    >
      <div className={classNames.gridContainer}>
        <div className={classNames.navigation}>
          <CardDetails title="Agence" isOpen={false}>
            <div>
              <h2 className="mbl-3">{agenceName}</h2>
              <address className="flex">
                <Icon
                  icon="emplacement"
                  color="var(--primary-text-color)"
                  width="28"
                  height="21"
                />
                &nbsp;
                <a
                  href={`https://www.google.com/maps/place/${agenceAdresse}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {agenceAdresse}
                </a>
              </address>
              <p className="flex align-items-center mbl-3">
                <Icon
                  icon="user"
                  color="var(--primary-text-color)"
                />
                &nbsp; {agenceCollegues} collègues dans cette agence
              </p>
              <Button
                aspect="unstyled"
                size="small"
                color="primary"
                to={`/agences/${agenceSlug}`}
              >
                <Icon icon="arrowRight" /> Découvrir l'agence
              </Button>
            </div>
          </CardDetails>
          <CardDetails title="Poste" isOpen={true}>
            <h2 className="mbl-3">{jobTitle}</h2>
            <div className="tags gap-1 d-flex justify-content-between">
              {criteres.map((critere, index) => {
                return (
                  <Button
                    key={index}
                    aspect="tag"
                    size="small"
                    color="primary"
                  >
                    <Icon
                      icon={critere.attributes.type}
                      width="22"
                      height="22"
                    />
                    {critere.attributes.value}
                  </Button>
                )
              })}
              {jobSalaryAmount && (
                <Button
                  aspect="tag"
                  size="small"
                  color="primary"
                >
                  <Icon
                    icon="salaryAmount"
                    width="21"
                    height="20"
                  />
                  env. {jobSalaryAmount}k.
                </Button>
              )}
            </div>
          </CardDetails>
          <div>
            <Card className={`quartary-background-color no-shadow flex align-items-center p-3 ${classNames.wantedJob}`}>
              <p className="fs-20">
                Ce poste
                vous intéresse ?
              </p>
              <Button
                aspect={isMobileDevice() ? "contrastant" : "classique"}
                size="medium"
                color="primary"
                onClick={()=> {
                  navigate('/pop-in/candidature-1?annonceEmail='+encodeURIComponent(applicationEmail)+'&annonceTitle='+encodeURIComponent(jobTitle), {
                    state: {
                      modal: true,
                      agence: agenceName,
                      slug: agenceSlug
                    },
                  })
                }}
                className="mt- mt-lg-0 ml-lg-auto"
              >
                Postuler
              </Button>
            </Card>
          </div>
        </div>
        <article className={classNames.template}>
          <CardDetails
            isOpen
            title="Missions et responsabilités principales"
            className="quinary-background-color no-shadow p-3"
          >
            <div
              className={classNames.mission}
              dangerouslySetInnerHTML={{ __html: jobMission }}
            />
          </CardDetails>
          <CardDetails
            isOpen
            title="Profil recherché"
            className="quinary-background-color no-shadow p-3"
          >
            <div
              className={classNames.profile}
              dangerouslySetInnerHTML={{ __html: jobProfile}}
            />
          </CardDetails>
          {/* <CardDetails
            isOpen
            title="Compétences recherchées"
            className="quinary-background-color no-shadow p-3"
          >
            <div>{jobSkills}</div>
          </CardDetails> */}
          {/* <CardDetails
            isOpen
            title="Compétences recherchées"
            className="quinary-background-color no-shadow p-3"
          >
            <div>{jobSkills}</div>
          </CardDetails> */}
          {/* <CardDetails
            isOpen
            title="Perspectives d'évolution"
            className="quinary-background-color no-shadow p-3"
          >
            <div>
              <p>Évolutions :</p>
              <ul>
                <li>Business Developper</li>
                <li>Chef des ventes</li>
              </ul>
              <Button
                aspect="unstyled"
                size="small"
                color="primary"
                to="/agence"
              >
                <Icon icon="arrowRightLink" /> Découvrir les métiers du service
                commercial chez Paritel
              </Button>
              <p className="mt-3">Certifications :</p>
              <ul>
                <li>BD et BD Confirmé = certification au cours du 4ème mois</li>
                <li>
                  BD Master et expert = certification au cours du 5ème mois
                </li>
              </ul>
              <Button
                aspect="unstyled"
                size="small"
                color="primary"
                to="/agence"
              >
                <Icon icon="arrowRightLink" /> Lire l’article "Élevez-vous avec
                Paritel"
              </Button>
            </div>
          </CardDetails> */}
          <CardDetails
            isOpen={isMobileDevice() ? false : true}
            title="Étapes du recrutement"
            className="quinary-background-color no-shadow p-3"
          >
            <div>
              <ul className="checks">
                <li>
                  Un entretien téléphonique ou en visioconférence avec notre
                  service recrutement
                </li>
                <li>
                  Une rencontre avec votre top manager pour vérifier que tes
                  motivations sont en phase avec nos objectifs
                </li>
                <li>Un badge, un café, bienvenue chez Paritel</li>
              </ul>
            </div>
          </CardDetails>
          <Card className={`${classNames.poste} p-3 text-center`}
          >
            <p className="fs-32">Ce poste vous intéresse ?</p>
            <p className="mbl-3">Devenez notre nouveau {jobTitle}</p>
            <Button
              aspect="contrastant"
              size="large"
              color="primary"
              //to="/pop-in/candidature-1"
              onClick={()=> {
                navigate('/pop-in/candidature-1?annonceEmail='+encodeURIComponent(applicationEmail)+'&annonceTitle='+encodeURIComponent(jobTitle), {
                  state: {
                    modal: true,
                    agence: agenceName,
                    slug: agenceSlug
                  },
                })
              }}
            >
              Postuler
            </Button>
          </Card>
        </article>
        <div>
          <DialogApplicationForm />
        </div>
      </div>
    </Section>
  )
}

// export function Head() {
//   return (
//     <>
//       <script type="application/ld+json">
//         {`
//           {
//             "@context" : "https://schema.org/",
//             "@type" : "JobPosting",
//             "title" : "Software Engineer",
//             "description" : "<p>Google aspires to be an organization that reflects the globally diverse audience that our products and technology serve. We believe that in addition to hiring the best talent, a diversity of perspectives, ideas and cultures leads to the creation of better products and services.</p>",
//             "identifier": {
//               "@type": "PropertyValue",
//               "name": "Google",
//               "value": "1234567"
//             },
//             "datePosted" : "2017-01-18",
//             "validThrough" : "2017-03-18T00:00",
//             "employmentType" : "CONTRACTOR",
//             "hiringOrganization" : {
//               "@type" : "Organization",
//               "name" : "Google",
//               "sameAs" : "https://www.google.com",
//               "logo" : "https://www.example.com/images/logo.png"
//             },
//             "jobLocation": {
//             "@type": "Place",
//               "address": {
//               "@type": "PostalAddress",
//               "streetAddress": "1600 Amphitheatre Pkwy",
//               "addressLocality": "Mountain View",
//               "addressRegion": "CA",
//               "postalCode": "94043",
//               "addressCountry": "US"
//               }
//             },
//             "baseSalary": {
//               "@type": "MonetaryAmount",
//               "currency": "USD",
//               "value": {
//                 "@type": "QuantitativeValue",
//                 "value": 40.00,
//                 "unitText": "HOUR"
//               }
//             }
//           }
//         `}
//       </script>
//     </>
//   )
// }

export const name = "CtxJobAdViewerSection"

export const init = (componentData, pageContext) => {
  // console.log(
  //   'here',
  //   pageContext.itemData?.attributes?.agence?.data?.attributes
  // )
  const jobTitle = pageContext.itemData?.attributes?.title
  const jobMission = pageContext.itemData?.attributes?.mission

  const jobSkills = pageContext.itemData?.attributes?.skills
  const jobProfile = pageContext.itemData?.attributes?.profile
  const jobCriteres = pageContext.itemData?.attributes?.criterias

  const jobExpManagementYears =
    pageContext.itemData?.attributes?.expManagementYears
  const jobExpYears = pageContext.itemData?.attributes?.expYears

  const jobContractDurationUnit =
    pageContext.itemData?.attributes?.contractDurationUnit
  const jobContractDurationValue =
    pageContext.itemData?.attributes?.contractDurationValue

  const jobSalaryMax = pageContext.itemData?.attributes?.salaryMax
  const jobSalaryMin = pageContext.itemData?.attributes?.salaryMin
  const jobSalaryUnit = pageContext.itemData?.attributes?.salaryUnit
  const jobSalaryAmount = pageContext.itemData?.attributes?.salaryAmount
  const applicationEmail =  pageContext.itemData?.attributes?.applicationEmail;
  const agenceCity =
    pageContext.itemData?.attributes?.agence?.data?.attributes?.city
  const agencePostalCode =
    pageContext.itemData?.attributes?.agence?.data?.attributes?.postalCode
  const agenceAdresse =
    pageContext.itemData?.attributes?.agence?.data?.attributes?.adresse
  const agenceName =
    pageContext.itemData?.attributes?.agence?.data?.attributes?.name
  const agenceSlug =
    pageContext.itemData?.attributes?.agence?.data?.attributes?.slug
  const agenceCollegues =
    pageContext.itemData?.attributes?.agence?.data?.attributes?.collegues
  return (
    <CtxJobAdViewerSection
      key={componentData.id}
      jobMission={jobMission}
      jobTitle={jobTitle}
      jobSkills={jobSkills}
      jobProfile={jobProfile}
      jobCriteres={jobCriteres}
      jobExpManagementYears={jobExpManagementYears}
      jobExpYears={jobExpYears}
      jobContractDurationUnit={jobContractDurationUnit}
      jobContractDurationValue={jobContractDurationValue}
      jobSalaryMax={jobSalaryMax}
      jobSalaryMin={jobSalaryMin}
      jobSalaryUnit={jobSalaryUnit}
      jobSalaryAmount={jobSalaryAmount}
      applicationEmail={applicationEmail}
      agenceCity={agenceCity}
      agencePostalCode={agencePostalCode}
      agenceAdresse={agenceAdresse}
      agenceName={agenceName}
      agenceSlug={agenceSlug}
      agenceCollegues={agenceCollegues}
    />
  )
}

export default CtxJobAdViewerSection
